export enum DASHBOARD_HTTPS_CODES {
	SUCCESS = 200,
	INVALID_TOKEN = 401,
}
